var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Chip, Paper } from "@material-ui/core";
import React from "react";
var StyledChip = styled(Chip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    margin-right: 10px;\n  }\n"], ["\n  && {\n    margin-right: 10px;\n  }\n"])));
var StyledPointsPaper = styled(function (_a) {
  var points = _a.points,
    props = __rest(_a, ["points"]);
  return React.createElement(Paper, __assign({}, props));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-left: 10px solid #4caf50;\n  margin: 5px;\n  padding: 10px;\n"], ["\n  border-left: 10px solid #4caf50;\n  margin: 5px;\n  padding: 10px;\n"])));
var Points = function Points(_a) {
  var points = _a.points;
  var t = useTranslation()[0];
  var mapPoints = function mapPoints() {
    return points.map(function (point) {
      return React.createElement(StyledChip, {
        key: point,
        label: point,
        variant: "outlined"
      });
    });
  };
  return React.createElement(StyledPointsPaper, {
    points: true,
    "data-cy": "submission-points"
  }, t("pointsAwarded"), ": ", mapPoints());
};
export default Points;
var templateObject_1, templateObject_2;